export default __webpack_public_path__ + "static/media/calendar-icon.d6c674b1.svg";